import { SessionService } from '@absg/nim-client-shared';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { StationInfoService } from 'core.services/station-info.service';
import { Observable, Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { StationManagementService } from 'shared.root/services/state-management/station-management.service';

import { CmsService } from '../shared/services/cms.service';

@Component({
  selector: '[nc-switch-station]',
  templateUrl: './switch-station.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SwitchStationComponent implements AfterViewInit, OnDestroy {
  stationName = '';

  @Input() isModalOpen$: Observable<boolean>;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose = new EventEmitter();
  @ViewChild('stationNameInput', { static: true }) stationNameField: ElementRef;
  componentIsDestroyed = new Subject<void>();

  constructor(
    private stationInfoService: StationInfoService,
    private sessionService: SessionService,
    private cmsService: CmsService,
    private stationManagementService: StationManagementService,
  ) { }

  ngAfterViewInit(): void {
    this.isModalOpen$.pipe(
      takeUntil(this.componentIsDestroyed),
      delay(50),
    ).subscribe((isOpen) => {
      if (isOpen) {
        this.stationNameField.nativeElement.focus();
        this.stationNameField.nativeElement.select();
      }
    });
  }

  ngOnDestroy(): void {
    this.componentIsDestroyed.next();
    this.componentIsDestroyed.unsubscribe();
  }

  onSwitchClick(): void {
    if (this.stationName && this.stationName !== '') {
      this.stationManagementService.resetCache(true); // clears at least formulary so we load fresh
      this.stationInfoService.hostName.next(this.stationName);
      this.stationInfoService.practiceClinicDetail.next(null);
      this.sessionService.isLoginEnabled.next(false);
      this.stationInfoService.publishHostName(this.stationName);
      this.cmsService.setCmsURl(null);
      this.onClose.emit();
    }
  }

  onCancelClick(): void {
    this.onClose.emit();
  }
}
